/**
 * Uploads typed API (Phase 7). Every shape — path params, resolved value —
 * derives from the SERVER's route defs via the type-only import below (erased
 * at build; no server code reaches the bundle). A server-side shape change
 * breaks this file and its callers at compile time.
 *
 * The upload POST is deliberately NOT here: it sends multipart/form-data and
 * the def declares no input schema — typedRoute is JSON-only — so the page
 * hand-rolls that fetch (see uploads.page.tsx).
 */
import { typedRoute } from "@d12labs/client";
import type { uploadsRouteDefs } from "../server/routes";

export const uploadsApi = {
	list: typedRoute<typeof uploadsRouteDefs.list>()("GET", "/api/plugins/uploads/files"),
	remove: typedRoute<typeof uploadsRouteDefs.remove>()("DELETE", "/api/plugins/uploads/files/:id"),
	url: typedRoute<typeof uploadsRouteDefs.url>()("GET", "/api/plugins/uploads/files/:id/url"),
};

/** The server's upload row shape (with previewUrl), derived — never redeclared by hand. */
export type UploadRecord = Awaited<ReturnType<typeof uploadsApi.list>>[number];
